import { TLoadListingOffersMode } from '../../listingOffers';

export function getNextPageNumber(mode: TLoadListingOffersMode, currentPage: number): number {
  if (mode === 'next') {
    return currentPage + 1;
  }

  if (mode === 'prev') {
    return Math.max(1, currentPage - 1);
  }

  return 1;
}
